import { SystemConstants } from "src/common/constants";

const LOGIN = 'LOGIN';
export const LOGIN_API = LOGIN + SystemConstants.API_LOADER.TRIGGER_SUFFIX;
export const LOGIN_SUCCESS = LOGIN + SystemConstants.API_LOADER.SUCCESS_SUFFIX;
export const LOGIN_ERROR = LOGIN + SystemConstants.API_LOADER.ERROR_SUFFIX;

const LOGOUT = 'LOGOUT';
export const LOGOUT_API = LOGOUT + SystemConstants.API_LOADER.TRIGGER_SUFFIX;